import { useState, useEffect } from "react";
import { C } from "./utils";

const API = "https://cip.medsphere.net/api";

async function apiGet(endpoint, params, authCode) {
  const q = new URLSearchParams(params);
  const r = await fetch(`${API}/${endpoint}?${q}`, { headers:{"Auth-Code":authCode} });
  return r.json();
}
async function apiPost(endpoint, body, authCode) {
  const fd = new FormData();
  Object.entries(body).forEach(([k,v]) => fd.append(k, v));
  const r = await fetch(`${API}/${endpoint}`, { method:"POST", headers:{"Auth-Code":authCode}, body:fd });
  return r.json();
}

function Toggle({ on, onChange, primary }) {
  return (
    <div onClick={onChange}
      style={{width:34,height:18,borderRadius:9,position:"relative",cursor:"pointer",
        background:on?primary:"#CBD5E1",transition:"background .2s",flexShrink:0}}>
      <div style={{position:"absolute",top:1,left:on?15:1,width:16,height:16,
        borderRadius:"50%",background:"#fff",boxShadow:"0 1px 3px rgba(0,0,0,0.2)",
        transition:"left .2s"}}/>
    </div>
  );
}

function Toast({ toast }) {
  if(!toast) return null;
  return (
    <div style={{position:"fixed",bottom:24,right:24,zIndex:3000,
      padding:"10px 18px",borderRadius:20,fontSize:13,fontWeight:500,
      background:toast.ok?"#E1F5EE":"#FEF2F2",
      color:toast.ok?"#1D9E75":"#B91C1C",
      border:`1px solid ${toast.ok?"#6FCFA7":"#FECACA"}`,
      boxShadow:"0 4px 16px rgba(0,0,0,0.1)",
      animation:"usTst .2s ease"}}>
      {toast.ok?"✓":"⚠"} {toast.msg}
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div style={{background:"#fff",borderRadius:12,border:`1px solid ${C.border}`,overflow:"hidden"}}>
      <div style={{padding:"10px 16px",borderBottom:`1px solid ${C.border}`,
        fontSize:11,fontWeight:700,color:C.hint,textTransform:"uppercase",letterSpacing:"0.5px"}}>
        {title}
      </div>
      <div style={{padding:"14px 16px"}}>{children}</div>
    </div>
  );
}

function PwdField({ val, setVal, show, setShow, placeholder, err, onClear }) {
  return (
    <div>
      <div style={{position:"relative"}}>
        <input type={show?"text":"password"} value={val}
          onChange={e=>{ setVal(e.target.value); if(onClear) onClear(); }}
          placeholder={placeholder}
          style={{width:"100%",boxSizing:"border-box",padding:"7px 36px 7px 10px",
            borderRadius:7,border:`1px solid ${err?C.error:C.border}`,fontSize:12,
            color:C.text,background:err?"#FFF5F5":"#fff",outline:"none",fontFamily:"inherit"}}/>
        <button type="button" onClick={()=>setShow(p=>!p)}
          style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",
            background:"none",border:"none",cursor:"pointer",color:C.hint,padding:2}}>
          {show
            ?<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          }
        </button>
      </div>
      {err&&<div style={{fontSize:10,color:C.error,marginTop:2}}>{err}</div>}
    </div>
  );
}

// ── Mobile number section with OTP change flow ────────────────────────────────
function MobileSection({ user, currentMobile, onUpdated }) {
  const [mode,    setMode]    = useState("view"); // view | edit | otp
  const [mobile,  setMobile]  = useState("");
  const [otp,     setOtp]     = useState("");
  const [loading, setLoading] = useState(false);
  const [err,     setErr]     = useState("");
  const [ok,      setOk]      = useState("");

  const requestOtp = async () => {
    if(!mobile.trim()) return setErr("Enter a mobile number.");
    setLoading(true); setErr(""); setOk("");
    try {
      const fd = new FormData();
      fd.append("userid", user.USERID);
      fd.append("mobile", mobile.trim());
      const r   = await fetch(`${API}/request_mobile_otp`,
        {method:"POST",headers:{"Auth-Code":user.AUTH_CODE},body:fd});
      const res = await r.json();
      if(res.STATUS==="1"||res.STATUS===1) setMode("otp");
      else setErr(res.MESSAGE||"Failed to send OTP.");
    } catch { setErr("Network error."); }
    setLoading(false);
  };

  const verifyOtp = async () => {
    if(!otp.trim()) return setErr("Enter the OTP.");
    setLoading(true); setErr(""); setOk("");
    try {
      const fd = new FormData();
      fd.append("userid", user.USERID);
      fd.append("mobile", mobile.trim());
      fd.append("otp",    otp.trim());
      const r   = await fetch(`${API}/update_mobile`,
        {method:"POST",headers:{"Auth-Code":user.AUTH_CODE},body:fd});
      const res = await r.json();
      if(res.STATUS==="1"||res.STATUS===1){
        setOk("Mobile updated successfully!");
        setMode("view"); setOtp(""); setMobile("");
        onUpdated(mobile.trim());
      } else setErr(res.MESSAGE||"Invalid OTP.");
    } catch { setErr("Network error."); }
    setLoading(false);
  };

  const cancel = () => { setMode("view"); setMobile(""); setOtp(""); setErr(""); setOk(""); };

  return (
    <div style={{padding:"8px 0",borderTop:`1px solid ${C.border}`}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",
        marginBottom:4}}>
        <span style={{fontSize:10,fontWeight:700,color:C.hint,
          textTransform:"uppercase",letterSpacing:"0.4px"}}>Mobile</span>
        {mode==="view"&&(
          <button onClick={()=>{ setMode("edit"); setMobile(currentMobile); setErr(""); setOk(""); }}
            style={{fontSize:10,fontWeight:600,color:C.primary,background:"none",
              border:"none",cursor:"pointer",padding:0}}>
            {currentMobile?"Change":"+ Add"}
          </button>
        )}
      </div>

      {mode==="view"&&(
        <>
          <div style={{fontSize:12,color:C.text,fontWeight:500}}>
            {currentMobile||"—"}
          </div>
          {ok&&<div style={{fontSize:11,color:"#16A34A",marginTop:4}}>{ok}</div>}
        </>
      )}

      {mode==="edit"&&(
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          <input value={mobile} onChange={e=>setMobile(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&requestOtp()}
            placeholder="+1 (555) 000-0000"
            style={{padding:"7px 10px",borderRadius:7,fontSize:13,fontFamily:"inherit",
              border:`1.5px solid ${err?C.error:C.border}`,outline:"none",width:"100%",boxSizing:"border-box"}}/>
          {err&&<div style={{fontSize:11,color:C.error}}>{err}</div>}
          <div style={{display:"flex",gap:6}}>
            <button onClick={requestOtp} disabled={loading}
              style={{flex:1,padding:"7px",borderRadius:7,border:"none",
                background:C.primary,color:"#fff",fontSize:12,fontWeight:600,
                cursor:loading?"not-allowed":"pointer",opacity:loading?0.7:1}}>
              {loading?"Sending…":"Send OTP"}
            </button>
            <button onClick={cancel}
              style={{padding:"7px 12px",borderRadius:7,border:`1px solid ${C.border}`,
                background:"none",color:C.muted,fontSize:12,cursor:"pointer"}}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {mode==="otp"&&(
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          <div style={{fontSize:11,color:C.muted}}>OTP sent to {mobile}</div>
          <input value={otp} onChange={e=>setOtp(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&verifyOtp()}
            placeholder="Enter OTP"
            maxLength={8}
            style={{padding:"7px 10px",borderRadius:7,fontSize:18,letterSpacing:6,
              textAlign:"center",fontFamily:"inherit",
              border:`1.5px solid ${err?C.error:C.border}`,outline:"none",
              width:"100%",boxSizing:"border-box"}}/>
          {err&&<div style={{fontSize:11,color:C.error}}>{err}</div>}
          <div style={{display:"flex",gap:6}}>
            <button onClick={verifyOtp} disabled={loading}
              style={{flex:1,padding:"7px",borderRadius:7,border:"none",
                background:C.primary,color:"#fff",fontSize:12,fontWeight:600,
                cursor:loading?"not-allowed":"pointer",opacity:loading?0.7:1}}>
              {loading?"Verifying…":"Verify & Save"}
            </button>
            <button onClick={()=>{setMode("edit");setOtp("");setErr("");}}
              style={{padding:"7px 12px",borderRadius:7,border:`1px solid ${C.border}`,
                background:"none",color:C.muted,fontSize:12,cursor:"pointer"}}>
              ←
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default function UserSettings({ user, activeSub, theme, onClose }) {
  const primary = theme?.primary || C.primary;
  const [toast,     setToast]     = useState(null);
  const [loading,   setLoading]   = useState(true);

  // profile
  const [email,     setEmail]     = useState("");
  const [mobile,    setMobile]    = useState("");

  // password
  const [oldPwd,    setOldPwd]    = useState("");
  const [newPwd,    setNewPwd]    = useState("");
  const [showOld,   setShowOld]   = useState(false);
  const [showNew,   setShowNew]   = useState(false);
  const [pwdErr,    setPwdErr]    = useState({});
  const [pwdSaving, setPwdSaving] = useState(false);

  // alerts
  const [alerts,    setAlerts]    = useState([]);
  const [alertSave, setAlertSave] = useState(false);
  const [dnd,       setDnd]       = useState(false);
  const [dndSaving, setDndSaving] = useState(false);

  // default tab
  const [tabs,      setTabs]      = useState([]);
  const [defTab,    setDefTab]    = useState(null);

  const showToast = (ok, msg) => {
    setToast({ok,msg});
    setTimeout(()=>setToast(null), 2800);
  };

  useEffect(()=>{
    if(!user||!activeSub) return;
    Promise.all([
      apiGet("setalert_view", {userid:user.USERID, subprojectid:activeSub.SUBPROJECTID}, user.AUTH_CODE),
      apiGet("defaultpage_view", {userid:user.USERID, subprojectid:activeSub.SUBPROJECTID}, user.AUTH_CODE),
    ]).then(([ar, dr])=>{
      if(ar.STATUS==="1"&&Array.isArray(ar.DATA)) {
        setAlerts(ar.DATA.filter(a=>a.isSelected!==null));
        if(ar.DND!==undefined) setDnd(Number(ar.DND)===0);
      }
      if(dr.STATUS==="1"&&Array.isArray(dr.DATA)) {
        setTabs(dr.DATA.filter(t=>t.key!==undefined&&t.isSelected==="1"));
        const defItem = dr.DATA.find(t=>t["MY DEFAULT"]!==undefined);
        setDefTab(defItem ? String(defItem["MY DEFAULT"]) : "0");
      }
    }).catch(()=>{}).finally(()=>setLoading(false));
    // email/mobile come directly from the login response
    setEmail(user.EMAIL||"");
    setMobile(user.PHONENUMBER||user.MOBILE||"");
  },[]);

  const savePassword = async () => {
    const errs = {};
    if(!oldPwd.trim()) errs.old = "Enter current password";
    else if(oldPwd.trim() !== (user.PASSWORD||"").trim()) errs.old = "Incorrect current password";
    if(!newPwd.trim()) errs.new = "Enter new password";
    else if(newPwd.trim().length < 6) errs.new = "Min 6 characters";
    else if(newPwd.trim() === oldPwd.trim()) errs.new = "Must be different";
    setPwdErr(errs);
    if(Object.keys(errs).length>0) return;
    setPwdSaving(true);
    try {
      const r = await apiPost("change_password",{userid:user.USERID,pwd:newPwd.trim()},user.AUTH_CODE);
      if(r.STATUS==="1"||r.STATUS===1) {
        showToast(true,"Password updated!");
        setOldPwd(""); setNewPwd(""); setPwdErr({});
      } else showToast(false,r.MESSAGE||"Failed");
    } catch { showToast(false,"Network error"); }
    setPwdSaving(false);
  };

  const toggleDnd = async () => {
    if(dndSaving) return;
    setDndSaving(true);
    const newDnd = !dnd;
    setDnd(newDnd);
    try {
      // dnd=0 means activate DND (mute), dnd=1 means deactivate (unmute)
      const r = await apiPost("dnd",{userid:user.USERID, dnd:newDnd?0:1},user.AUTH_CODE);
      if(r.STATUS==="1"||r.STATUS===1)
        showToast(true, newDnd?"Do Not Disturb on":"Do Not Disturb off");
      else { setDnd(!newDnd); showToast(false,r.MESSAGE||"Failed"); }
    } catch { setDnd(!newDnd); showToast(false,"Network error"); }
    setDndSaving(false);
  };

  const saveAlerts = async () => {
    setAlertSave(true);
    try {
      const body = {userid:user.USERID,subprojectid:activeSub.SUBPROJECTID};
      alerts.forEach(a=>{ body[a.key]=a.isSelected; });
      const r = await apiPost("set_alerts",body,user.AUTH_CODE);
      if(r.STATUS==="1"||r.STATUS===1) showToast(true,"Alerts saved!");
      else showToast(false,r.MESSAGE||"Failed");
    } catch { showToast(false,"Network error"); }
    setAlertSave(false);
  };

  const saveDefault = async (key) => {
    const prev = defTab;
    setDefTab(key);
    try {
      const r = await apiPost("set_default",
        {userid:user.USERID,subprojectid:activeSub.SUBPROJECTID,default:key},
        user.AUTH_CODE);
      if(r.STATUS==="1"||r.STATUS===1) showToast(true,"Default tab updated!");
      else { setDefTab(prev); showToast(false,r.MESSAGE||"Failed"); }
    } catch { showToast(false,"Network error"); }
  };

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden",background:"#F7F9FC"}}>

      {/* header */}
      <div style={{background:"#fff",borderBottom:`1px solid ${C.border}`,
        padding:"11px 20px",display:"flex",alignItems:"center",gap:12,flexShrink:0}}>
        <button onClick={onClose}
          style={{width:26,height:26,borderRadius:7,border:`1px solid ${C.border}`,
            background:"#F7F9FC",color:C.muted,cursor:"pointer",fontSize:13,
            display:"flex",alignItems:"center",justifyContent:"center"}}>←</button>
        <div style={{fontSize:14,fontWeight:700,color:C.text}}>Settings</div>
      </div>

      {loading
        ? <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",
            color:C.hint,fontSize:13}}>Loading…</div>
        : <div style={{flex:1,overflowY:"auto",padding:"16px"}}>
            {/* 3-col grid */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:14,
              maxWidth:1100,margin:"0 auto"}}>

              {/* col 1: Profile + Password */}
              <div style={{display:"flex",flexDirection:"column",gap:14}}>
                <Card title="Profile">
                  <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                    <div style={{width:44,height:44,borderRadius:"50%",flexShrink:0,
                      background:`${primary}20`,display:"flex",alignItems:"center",
                      justifyContent:"center",fontSize:16,fontWeight:700,color:primary}}>
                      {(user.FIRSTNAME?.[0]||"")+(user.LASTNAME?.[0]||"")}
                    </div>
                    <div>
                      <div style={{fontSize:14,fontWeight:700,color:C.text}}>
                        {user.FIRSTNAME} {user.LASTNAME}
                      </div>
                      <div style={{fontSize:11,color:C.hint}}>{user.PROJECTNAME}</div>
                    </div>
                  </div>
                  {/* Email — read only */}
                  <div style={{padding:"8px 0",borderTop:`1px solid ${C.border}`}}>
                    <span style={{fontSize:10,fontWeight:700,color:C.hint,
                      textTransform:"uppercase",letterSpacing:"0.4px"}}>Email</span>
                    <div style={{fontSize:12,color:C.text,fontWeight:500,marginTop:2}}>
                      {email||user.EMAIL||"—"}
                    </div>
                  </div>

                  {/* Mobile — show + change */}
                  <MobileSection user={user} currentMobile={mobile||user.PHONENUMBER||user.MOBILE||""}
                    onUpdated={mob=>setMobile(mob)}/>
                </Card>

                <Card title="Change Password">
                  <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    <div>
                      <div style={{fontSize:10,fontWeight:700,color:C.hint,
                        textTransform:"uppercase",letterSpacing:"0.4px",marginBottom:4}}>
                        Current Password
                      </div>
                      <PwdField val={oldPwd} setVal={setOldPwd}
                        show={showOld} setShow={setShowOld}
                        placeholder="Current password"
                        err={pwdErr.old} onClear={()=>setPwdErr({})}/>
                    </div>
                    <div>
                      <div style={{fontSize:10,fontWeight:700,color:C.hint,
                        textTransform:"uppercase",letterSpacing:"0.4px",marginBottom:4}}>
                        New Password
                      </div>
                      <PwdField val={newPwd} setVal={setNewPwd}
                        show={showNew} setShow={setShowNew}
                        placeholder="New password"
                        err={pwdErr.new} onClear={()=>setPwdErr({})}/>
                    </div>
                    <button onClick={savePassword} disabled={pwdSaving}
                      style={{padding:"8px",borderRadius:7,border:"none",
                        background:pwdSaving?"#aaa":primary,color:"#fff",
                        fontSize:12,fontWeight:600,cursor:pwdSaving?"wait":"pointer"}}>
                      {pwdSaving?"Updating…":"Update Password"}
                    </button>
                  </div>
                </Card>
              </div>

              {/* col 2: Notification Alerts */}
              <Card title="Notification Alerts">
                <div style={{display:"flex",flexDirection:"column"}}>
                  {/* DND toggle */}
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",
                    padding:"8px 12px",borderRadius:8,marginBottom:10,
                    background:dnd?`#FEF2F2`:"#F0FDF4",
                    border:`1px solid ${dnd?"#FECACA":"#BBF7D0"}`}}>
                    <div>
                      <div style={{fontSize:12,fontWeight:700,
                        color:dnd?"#DC2626":"#16A34A"}}>
                        {dnd?"🔕 Do Not Disturb — ON":"🔔 Do Not Disturb — OFF"}
                      </div>
                      <div style={{fontSize:10,color:dnd?"#FCA5A5":"#86EFAC",marginTop:1}}>
                        {dnd?"All notifications muted":"Notifications active"}
                      </div>
                    </div>
                    <Toggle on={dnd} primary={dnd?"#EF4444":"#16A34A"} onChange={toggleDnd}/>
                  </div>
                  {alerts.map((a,i)=>(
                    <div key={a.key}
                      style={{display:"flex",alignItems:"center",justifyContent:"space-between",
                        padding:"8px 0",
                        borderBottom:i<alerts.length-1?`1px solid ${C.border}`:"none"}}>
                      <span style={{fontSize:12,color:C.text,paddingRight:8,lineHeight:1.3}}>
                        {a.title}
                      </span>
                      <Toggle on={a.isSelected===1} primary={primary}
                        onChange={()=>setAlerts(prev=>prev.map(x=>
                          x.key===a.key?{...x,isSelected:x.isSelected===1?0:1}:x))}/>
                    </div>
                  ))}
                  <button onClick={saveAlerts} disabled={alertSave}
                    style={{marginTop:12,padding:"8px",borderRadius:7,border:"none",
                      background:alertSave?"#aaa":primary,color:"#fff",
                      fontSize:12,fontWeight:600,cursor:alertSave?"wait":"pointer"}}>
                    {alertSave?"Saving…":"Save Alerts"}
                  </button>
                </div>
              </Card>

              {/* col 3: Default Tab */}
              <Card title="Default Landing Tab">
                <div style={{display:"flex",flexDirection:"column",gap:5}}>
                  {tabs.map(t=>{
                    const sel = String(defTab)===String(t.key);
                    return(
                      <div key={t.key} onClick={()=>saveDefault(t.key)}
                        style={{display:"flex",alignItems:"center",justifyContent:"space-between",
                          padding:"7px 10px",borderRadius:7,cursor:"pointer",
                          border:`1px solid ${sel?primary:C.border}`,
                          background:sel?`${primary}08`:"#F7F9FC",
                          transition:"all .12s"}}>
                        <span style={{fontSize:12,fontWeight:sel?600:400,
                          color:sel?primary:C.text}}>{t.title}</span>
                        {sel&&<svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke={primary} strokeWidth="2.5" strokeLinecap="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>}
                      </div>
                    );
                  })}
                </div>
              </Card>

            </div>
          </div>
      }

      <Toast toast={toast}/>
      <style>{`@keyframes usTst{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </div>
  );
}